import { render, staticRenderFns } from "./address-identification.vue?vue&type=template&id=3d3873e8&scoped=true&"
import script from "./address-identification.vue?vue&type=script&lang=js&"
export * from "./address-identification.vue?vue&type=script&lang=js&"
import style0 from "./address-identification.vue?vue&type=style&index=0&id=3d3873e8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3873e8",
  null
  
)

export default component.exports